import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from 'react-oidc-context'
import App from './App.tsx'
import ErrorBoundary from './components/ErrorBoundary'
import './index.css'

// Authority must be the User Pool OIDC discovery URL; discovery returns Hosted UI endpoints (authorize, token, etc.)
const cognitoAuthConfig = {
  authority: 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_7BleLBwcQ',
  client_id: '4v70pq3q7efhd63dlh90h62ejd',
  redirect_uri: 'https://mcp-frontend.aws-practice.royalcyber.org/',
  response_type: 'code',
  scope: 'email openid',
}

// Runtime info to aid debugging duplicate React versions
console.log('Runtime React version:', (React as any)?.version)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <BrowserRouter>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>,
)
